namespace app.legacy {
    "use strict";

    /** @ngInject **/
    function config($stateProvider: ng.ui.IStateProvider, msNavigationServiceProvider: any) {
        $stateProvider.state("app.legacy", {
            url : "/legacy/:context/{url:any}",
            parent : "app.autenticado",
            views: {
                "content@app.autenticado": {
                    templateUrl: "app/main/legacy/legacy.html",
                    controller: LegacyController,
                    controllerAs: "vm",
                    resolve: {
                        legacyMenuItems: /** @ngInject */ (legacyService: LegacyService) => {
                            return legacyService.legacyMenuItems();
                        },
                        frameUrl: /** @ngInject */ (properties: app.support.constants.Properties, $stateParams: ng.ui.IStateParamsService, $sce: ng.ISCEService,
                            legacyMenuItems: ILegacyMenu[]) => {
                            for (let legacyMenu of legacyMenuItems) {
                                if (legacyMenu.id === $stateParams["context"]) {
                                    return $sce.trustAsResourceUrl(properties.apiUrl + "/" + legacyMenu.id + "/#/" + $stateParams["url"]);
                                }
                            }
                        },
                        parentUrl: /** @ngInject */ ($window: ng.IWindowService) => {
                            return $window.location.origin;
                        }
                    }
                }
            }
        });
    }

    /** @ngInject */
    function run(legacyService: LegacyService) {
        legacyService.loadLegacyMenuItems();
    }

    angular
        .module("app.legacy", ["app.support"])
        .config(config)
        .run(run);
}